import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getMISReportSlice = createAsyncThunk(
  "mis/getMISReport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/misReport/getMISReport", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const downloadMISExcelSlice = createAsyncThunk(
  "mis/downloadMISExcel",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/misReport/downloadMISExcel", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
        responseType: "blob",
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

const initialState = {
  loading: false,
  summary: null,
  misData: [],
  chartData: [],
  error: null,

  reportSuccessMessage: null,
  reportErrorMessage: null,
  downloadLoading: false,
  downloadSuccessMessage: null,
  downloadErrorMessage: null,
};

const misReportSlice = createSlice({
  name: "misData",
  initialState,
  reducers: {
    resetMISMessages: (state) => {
      state.reportSuccessMessage = null;
      state.reportErrorMessage = null;
      state.downloadSuccessMessage = null;
      state.downloadErrorMessage = null;
    },
    resetMISData: (state) => {
      state.summary = null;
      state.misData = [];
      state.chartData = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMISReportSlice.pending, (state) => {
        state.loading = true;
        state.reportErrorMessage = null;
      })

      .addCase(getMISReportSlice.fulfilled, (state, action) => {
        state.loading = false;

        if (!action.payload.success) {
          state.summary = null;
          state.misData = [];
          state.chartData = []; 
          state.reportErrorMessage =
            action.payload.result?.message || "No data found";
          return;
        }

        const result = action.payload.result || {};

        state.summary = result.summary || null;
        state.misData = result.details || result.list || [];
        state.chartData = result.chart || [];

        state.reportSuccessMessage =
          action.payload.message || "Report fetched successfully";
      })

      .addCase(getMISReportSlice.rejected, (state, action) => {
        state.loading = false;
        state.reportErrorMessage = action.payload || "Something went wrong";
      })

      .addCase(downloadMISExcelSlice.pending, (state) => {
        state.downloadLoading = true;
        state.downloadErrorMessage = null;
      })

      .addCase(downloadMISExcelSlice.fulfilled, (state) => {
        state.downloadLoading = false;
        state.downloadSuccessMessage = "Excel downloaded successfully";
      })

      .addCase(downloadMISExcelSlice.rejected, (state, action) => {
        state.downloadLoading = false;
        state.downloadErrorMessage = action.payload || "Download failed";
      });
  },
});

export const { resetMISMessages, resetMISData } = misReportSlice.actions;

export default misReportSlice.reducer;
